export { default as CoreReportChart } from "./CoreReportChart";



// WEBPACK FOOTER //
// ./src/views/core/core_report_chart/index.js